import { useState } from "preact/hooks"
import { slugify } from "../../../utils"
import { useCustomConfig } from "../../../hooks/useCustomConfig"

const CATEGORY_GIFT_CARDS = 'Gift Cards'
const CATEGORY_COMING_SOON = 'Coming Soon Collection'
const CATEGORY_EASYGIFT = 'EasyGift All Products'
const TAG_GIFT_CARDS = 'Gift Cards'
const TAG_DIGITAL_PRODUCT = 'digital-product'
const TAG_BEST_SELLERS = 'Bestsellers'
const TAG_EXCLUSIVE_PRINT = 'ExclusivePrint'
const THRESHOLD_INVENTORY = 50
const LABEL_BADGE_COMING_SOON = "Coming Soon"
const LABEL_BADGE_ALMOST_GONE = 'Almost Gone'
const LABEL_BADGE_BEST_SELLER = 'Bestseller'
const LABEL_BADGE_EXCLUSIVE_PRINT = 'Exclusive Print'
const LABEL_BADGE_SOLD_OUT = 'Sold out'
const MAX_BADGES = 2

const isVirtualGiftCard = ({ product }) => {
    return (
        product.categories?.includes(CATEGORY_GIFT_CARDS) || 
        (product.tags1?.includes(TAG_DIGITAL_PRODUCT) && product.categories?.includes(TAG_GIFT_CARDS)) ||
        product.tags1?.includes(CATEGORY_EASYGIFT)
    );
};

const processLegacyBadges = ({ product }) => {
    if (product.categories.includes(CATEGORY_COMING_SOON)) {
        return { text: LABEL_BADGE_COMING_SOON };
    } else if (product.inventoryLevel < THRESHOLD_INVENTORY && !isVirtualGiftCard({ product })) {
        return { text: LABEL_BADGE_ALMOST_GONE };
    } else if (product.tags1.includes(TAG_BEST_SELLERS)) {
        return { text: LABEL_BADGE_BEST_SELLER };
    } else if (product.tags1.includes(TAG_EXCLUSIVE_PRINT)) {
        return { text: LABEL_BADGE_EXCLUSIVE_PRINT };
    }
    return null; 
};

const getLegacyBadges = ({ product }) => {
    
    let legacyBadges = []

    const processedLegacyBadges = processLegacyBadges({ product })  
    
    if (processedLegacyBadges) 
        legacyBadges = [...legacyBadges, { label: processedLegacyBadges.text, className: slugify(processedLegacyBadges.text), order: 1 }]

    if (!product.available) 
        legacyBadges = [...legacyBadges, { label: LABEL_BADGE_SOLD_OUT, className: 'sold-out', order: 1 }]

    return legacyBadges
    
}

const getProductBadges = ({ product, customBadges }) => {
    return customBadges
        .split(",")
        .map(b => b.trim())
        .map(customBadge => {
            return product.tags1.includes(customBadge) ?
                { label: customBadge, className: slugify(customBadge), order: 2 }
            : null
        })
        .filter(x => x !== null)
}

const getSaleLabel = ({ product, saleText }) => {
    const percent = Math.floor((parseFloat(product.listPrice) - parseFloat(product.price)) / parseFloat(product.listPrice) * 100)
    return saleText.replace('[percent]', percent)
}

const getSaleBadge = ({ product, saleText }) => {
    return product.listPrice > product.price ? { label: getSaleLabel({ product, saleText }), className: 'sale', order: 0 } : null
}

export const useProductBadges = ({ product }) => {
    
    const { customConfig } = useCustomConfig()
    const [badges, setBadges] = useState(() => {
        let badges = []
        const legacyBadges = customConfig.badges.enableLegacy ? 
            getLegacyBadges({ product }) : 
            []
        const productBadges = customConfig.badges.productBadges ? 
            getProductBadges({ product, customBadges: customConfig.badges.productBadges }) : 
            []
        const saleBadge = customConfig.badges.saleText !== "" ? 
            getSaleBadge({ product, saleText: customConfig.badges.saleText }) :
            null
        
        badges = [
            ...badges,
            ...legacyBadges,
            ...productBadges,
        ]
        if (saleBadge)
            badges = [...badges, saleBadge]

        // Sale badge always have to be second
        return badges
            .sort((a, b) => a.order > b.order ? 1 : -1)
            .splice(0, customConfig.badges.maxBadges)
            .reverse()
    })

    return { badges }
    
} 